// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.ordercollections.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/ordercollections/ordercollection/ordercollection.tpl.html',
            controller: 'OrderCollectionController as vm'
        }},
        resolve: {
            collection: function() { return {
                collectionCode: '',
                collectionDescription: '',
                articleCollectionType: 0,
                currentBehaviour: 0,
                currentRank: 0,
                currencySettings: [],
                duration: 360,
                isArticleSeason: false,
                isOrderSeason: true,
                offset: -180,
                currencies: []
            }; },
            currencies: currencyResolver,
            isNewCollection: function() { return true; }
        }
    });
    $stateProvider.state('base.ordercollections.ordercollection', {
        url:'/{collectionId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/ordercollections/ordercollection/ordercollection.tpl.html',
            controller: 'OrderCollectionController as vm'
        }},
        resolve: {
            collection: collectionResolver,
            currencies: currencyResolver,
            isNewCollection: function() { return false; }
        }
    });
}

// @ngInject
function collectionResolver($stateParams, OrderCollectionsApiService) {
    return OrderCollectionsApiService.getOrderCollectionById($stateParams.collectionId);
}

// @ngInject
function currencyResolver($stateParams, OrderCollectionsApiService) {
    return OrderCollectionsApiService.listAllCurrencies();
}

// @ngInject
function OrderCollectionController($window, $state, $scope, $translate, collection,
        currencies, loadSpinnerService, OrderCollectionsApiService,
        ToasterService, isNewCollection) {
    var vm = this;

    //Properties
    var collectionCopy = {};
    vm.isNewCollection = isNewCollection;
    vm.isEditing = vm.isNewCollection;
    vm.collection = collection;
    vm.currentBehaviours = [];
    vm.articleCollectionTypes = [];

    //Methods
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveCollection = saveCollection;
    vm.isAllInformationValid = isAllInformationValid;
    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();

        $scope.$watch(function() { return vm.collection.selectedCurrentBehaviour; }, function(newValue, oldValue) {
            if (newValue.id !== oldValue.id) {
                vm.collection.currentBehaviour = newValue.id;
            }
        });
        $scope.$watch(function() { return vm.collection.selectedArticleCollectionType; }, function(newValue, oldValue) {
            if (newValue.id !== oldValue.id) {
                vm.collection.articleCollectionType = newValue.id;
            }
        });

        if (isNewCollection) {
            loadSpinnerService.start('mainSpinner');
            vm.collections = [];
            OrderCollectionsApiService.listAllOrderCollections().then(function(response) {
                vm.collections = response;
                vm.collections = _.filter(vm.collections, function(c) { return c.toDate; });
                if (!isNewCollection) { vm.collections = _.filter(vm.collections, function(c) { return c.id !== vm.collection.id; }); }
                vm.collections = _.sortBy(vm.collections, ['toDate']);

                //Check which should be the next collection from date
                var lastCollection = vm.collections[vm.collections.length - 1];
                var lastToDate = lastCollection.toDate;
                var fromDate = new Date(lastToDate);
                fromDate.setDate(fromDate.getDate() + 1);
                var toDate = new Date(lastToDate);
                toDate.setDate(toDate.getDate() + 2);

                vm.collection.fromDate = fromDate;
                vm.collection.toDate = toDate;
            }, function(error) {
                console.log(error);
            }).then(function() {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function setCurrentBehaviours() {
        //DoNotSetCurrent, SetCurrent, SetNotCurrent
        vm.currentBehaviours.push({ id: 0, description: $translate.instant('articlecollection.currentBehaviourDoNotSetCurrent') });     //"DoNotSetCurrent"
        vm.currentBehaviours.push({ id: 1, description: $translate.instant('articlecollection.currentBehaviourSetCurrent') });          //"SetCurrent"
        vm.currentBehaviours.push({ id: 2, description: $translate.instant('articlecollection.currentBehaviourSetNotCurrent') });       //"SetNotCurrent"
    }

    function setArticleCollectionTypes() {
        //Static, Rolling
        vm.articleCollectionTypes.push({ id: 0, description: $translate.instant('articlecollection.articleCollectionTypeStatic') });     //"Static"
        vm.articleCollectionTypes.push({ id: 1, description: $translate.instant('articlecollection.articleCollectionTypeRolling') });    //"Rolling"
    }

    function enableEditing() {
        collectionCopy = angular.copy(vm.collection);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.collection = collectionCopy;
        vm.isEditing = false;
    }

    function saveCollection() {
        if (!vm.collection.collectionCode || vm.collection.collectionCode === 0) {
            ToasterService.showError($translate.instant('articlecollection.errorCollectionCodeEmpty'), $translate.instant('common.error'));
            $('#collectionCode').focus();
            return;
        }

        vm.collections = [];
        OrderCollectionsApiService.listAllOrderCollections().then(function(response) {
            vm.collections = response;
            vm.collections = _.filter(vm.collections, function(c) { return c.toDate; });
            if (!isNewCollection) { vm.collections = _.filter(vm.collections, function(c) { return c.id !== vm.collection.id; }); }
            vm.collections = _.sortBy(vm.collections, ['toDate']);

            //Check which should be the next collection from date
            //var lastCollection = vm.collections[vm.collections.length - 1];
            //var lastToDate = new Date(lastCollection.toDate);
            //var nextDate = new Date(lastToDate.toDateString());
            //nextDate.setDate(nextDate.getDate() + 1);
            //var cleanedFromDate = new Date(new Date(vm.collection.fromDate).toDateString());
            //var cleanedToDate = new Date(new Date(vm.collection.toDate).toDateString());

            //console.log('cleanedFromDate: ' + cleanedFromDate.getTime() + ', nextDate: ' + nextDate.getTime());

            if (vm.collection.collectionCode && vm.isNewCollection && _.find(response, function(r) { return r.collectionCode === vm.collection.collectionCode; })) {
                ToasterService.showError($translate.instant('articlecollection.errorCollectionCodeAlreadyPresent'), $translate.instant('common.error'));
                $('#collectionCode').focus();
                return;
            }
            //} else if (vm.collections.length > 0 &&
                // vm.collection.articleCollectionType === 0 &&
                // cleanedFromDate.getTime() >= cleanedToDate.getTime()) {
                //     //If from date is after to date
                //     vm.collection.toDate = new Date(vm.collection.fromDate);
                //     ToasterService.showError($translate.instant('articlecollection.errorFromDateAfterToDate'), $translate.instant('common.error'));
            // } else if (vm.collections.length > 0 &&
            //     vm.collection.articleCollectionType === 0 &&
            //     cleanedFromDate.getTime() < nextDate.getTime()) {
            //         //Confirm to save when from-date is before as to-date of last collection
            //         confirmationDialogService.showDialog($translate.instant('articlecollection.confirmDatesNotAligning') + ' Senaste säsong: ' + lastCollection.collectionCode + ' "' + lastCollection.collectionDescription + '", från och med-datum: ' + new Date(lastToDate.toDateString()).toDateString()).then(function (result) {
            //             if (result === true) {
            //                 if (isNewCollection) {
            //                     saveConfirmedCollection();
            //                 } else {
            //                     updateConfirmedCollection();
            //                 }
            //             } else {
            //                 vm.collection.fromDate = new Date(nextDate.toDateString());
            //                 ToasterService.showError($translate.instant('articlecollection.dateWasAdjusted'), $translate.instant('common.information'));
            //             }
            //         });

            if (isNewCollection) {
                saveConfirmedCollection();
            } else {
                updateConfirmedCollection();
            }
        }, function(error) {
            console.log(error);
        });
    }

    function saveConfirmedCollection() {
        var request = {
            articleCollectionType: vm.collection.selectedArticleCollectionType.id,
            collectionCode: vm.collection.collectionCode,
            collectionDescription: vm.collection.collectionDescription.trim(),
            currencySettings: [],
            currentBehaviour: vm.collection.selectedCurrentBehaviour.id,
            duration: vm.collection.duration,
            fromDate: getFullDate(vm.collection.fromDate),
            offset: vm.collection.offset,
            toDate: getFullDate(vm.collection.toDate)
        };
        //Add currency settings
        _.forEach(vm.collection.currencySettings, function(o) {
            request.currencySettings.push({
                currencyCode: o.currency.code,
                currencyRate: o.currencyRate
            });
        });

        loadSpinnerService.start('mainSpinner');
        OrderCollectionsApiService.saveOrderCollection(request).then(function(response) {
            $state.go('base.ordercollections.ordercollection', { collectionId: response.orderCollectionId });
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function getFullDate(date) {
        var year = new Date(date).getFullYear();
        var month = zeroFill(new Date(date).getMonth() + 1, 2);
        var day = zeroFill(new Date(date).getDate(), 2);

        return '' + year + '-' + month + '-' + day;
    }
    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            // eslint-disable-next-line wrap-regex
            return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }

    function updateConfirmedCollection() {
        var request = {
            articleCollectionId: vm.collection.id,
            collectionDescription: vm.collection.collectionDescription.trim(),
            currencySettings: [],
            currentBehaviour: vm.collection.selectedCurrentBehaviour.id,
            duration: vm.collection.duration,
            fromDate: getFullDate(vm.collection.fromDate),
            offset: vm.collection.offset,
            toDate: getFullDate(vm.collection.toDate)
        };
        //Add currency settings
        _.forEach(vm.collection.currencySettings, function(o) {
            request.currencySettings.push({
                currencyCode: o.currency.code,
                currencyRate: o.currencyRate
            });
        });

        loadSpinnerService.start('mainSpinner');
        OrderCollectionsApiService.updateOrderCollection(request).then(function(response) {
            $window.location.reload();
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }


    function toggleDisplayForm(collection) {
        collection.showEditForm = !collection.showEditForm;
    }

    function prepareData() {
        if (vm.collection === undefined) {
            return;
        }

        vm.collectionCopy = angular.copy(vm.collection);

        setCurrentBehaviours();
        setArticleCollectionTypes();

        vm.collection.selectedCurrentBehaviour = vm.currentBehaviours.find(function(element) { return element.id === vm.collection.currentBehaviour; });
        vm.collection.selectedArticleCollectionType = vm.articleCollectionTypes.find(function(element) { return element.id === vm.collection.articleCollectionType; });

        //If collection currency doesn't contain all available currencies, add them
        _.forEach(currencies, function(currency) {
            var existingCurrency;
            if (vm.collection.currencySettings.length > 0) {
                existingCurrency = vm.collection.currencySettings.find(function(element) {
                    return element.currency.code === currency.code;
                });
            }
            if (!existingCurrency) {
                var newCurrencySetting = {
                    currency: currency,
                    currencyRate: currency.currencyRate
                };
                vm.collection.currencySettings.push(newCurrencySetting);
            }
        });
    }

    function isAllInformationValid() {
        //return vm.collection.collectionCode.length > 0 && vm.collection.collectionDescription.length > 0;
        return true;
    }
}

angular
    .module('ordercollections.ordercollection', [])
    .config(stateConfig)
    .controller('OrderCollectionController', OrderCollectionController);
